// extracted by mini-css-extract-plugin
export default {"container":"Countdown_container__7qf6z","icon":"Countdown_icon__WGxwu","timer-elements":"Countdown_timer-elements__PxX9D"};